import type { AirgapAPI, TrackingConsentDetails } from '@transcend-io/airgap.js-types';

/**
 * Retrieve the current tracking consent details.
 *
 * @param airgapApi An instance of the AirgapAPI.
 */
export const getConsent = (airgapApi: AirgapAPI): TrackingConsentDetails => {
    return airgapApi.getConsent();
};
